import { SSN_SE_SECTION_ID } from '@/components/PriceCalculator/SsnSeSection'
import { useActiveFormSectionId } from '../useActiveFormSectionId'
import { usePriceCalculatorForm } from '../usePriceCalculatorForm'
import { usePriceCalculatorStep } from '../usePriceCalculatorStep'

// The condensed state is used to show the sticky header and hides the large product pillow
export function useCondensedProductHero() {
  const { step } = usePriceCalculatorStep()
  const { activeFormSectionId } = useActiveFormSectionId()
  const form = usePriceCalculatorForm()

  // Only in the fillForm step
  if (step !== 'fillForm') {
    return false
  }

  // But not for the SSN section
  if (activeFormSectionId === SSN_SE_SECTION_ID) {
    return false
  }

  // or the first section
  const activeSectionIndex = form.sections.findIndex((section) => section.id === activeFormSectionId)
  return activeSectionIndex > 0
}
